/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Machine from './Machine';

/**
 * The MachinesResponse model module.
 * @module model/MachinesResponse
 * @version 0.0.1
 */
class MachinesResponse {
    /**
     * Constructs a new <code>MachinesResponse</code>.
     * @alias module:model/MachinesResponse
     */
    constructor() { 
        
        MachinesResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MachinesResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MachinesResponse} obj Optional instance to populate.
     * @return {module:model/MachinesResponse} The populated <code>MachinesResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MachinesResponse();

            if (data.hasOwnProperty('machines')) {
                obj['machines'] = ApiClient.convertToType(data['machines'], [Machine]);
            }
            if (data.hasOwnProperty('totalRows')) {
                obj['totalRows'] = ApiClient.convertToType(data['totalRows'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MachinesResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MachinesResponse</code>.
     */
    static validateJSON(data) {
        if (data['machines']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['machines'])) {
                throw new Error("Expected the field `machines` to be an array in the JSON data but got " + data['machines']);
            }
            // validate the optional field `machines` (array)
            for (const item of data['machines']) {
                Machine.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/Machine>} machines
 */
MachinesResponse.prototype['machines'] = undefined;

/**
 * @member {Number} totalRows
 */
MachinesResponse.prototype['totalRows'] = undefined;






export default MachinesResponse;

